import { render, staticRenderFns } from "./RegistrationInfoFormModal.vue?vue&type=template&id=a6013f92&"
import script from "./RegistrationInfoFormModal.vue?vue&type=script&lang=ts&"
export * from "./RegistrationInfoFormModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports